import React from 'react';
import { RunManifestActor } from './RunManifestActor';

export interface ManifestActionsProps {
  manifestId: string;
  hide: () => void;
}

// tslint:disable-next-line:function-name
export function ManifestActions({ manifestId, hide }: ManifestActionsProps) {
  return (
    <div>
      <RunManifestActor onSubmit={hide} manifestId={manifestId} />
    </div>
  );
}
